import { ShipmentCard } from './shipment-card'
import type { ShipmentsCardViewProps } from '../types'

export function ShipmentsCardView({
  shipments,
  showTenantColumn,
  onCardClick,
  isArabic,
}: ShipmentsCardViewProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {shipments.map((shipment) => (
        <ShipmentCard
          key={shipment.id}
          shipment={shipment}
          showTenantColumn={showTenantColumn}
          onClick={() => onCardClick(shipment)}
          isArabic={isArabic}
        />
      ))}
    </div>
  )
}
